// Dynamically generated page index for client

import load from '@mna/react-client/load'

const Page_404 = load(() => import(/* webpackChunkName: "Page_404" */ '../pages/404'))
export { Page_404 }

const Page_CheckPolicy = load(() => import(/* webpackChunkName: "Page_CheckPolicy" */ '../pages/check-policy'))
export { Page_CheckPolicy }

const Page_CreateDetails = load(() => import(/* webpackChunkName: "Page_CreateDetails" */ '../pages/create-details'))
export { Page_CreateDetails }

const Page_CreatePrimary = load(() => import(/* webpackChunkName: "Page_CreatePrimary" */ '../pages/create-primary'))
export { Page_CreatePrimary }

const Page_CreateProfile = load(() => import(/* webpackChunkName: "Page_CreateProfile" */ '../pages/create-profile'))
export { Page_CreateProfile }

const Page_CreateUser = load(() => import(/* webpackChunkName: "Page_CreateUser" */ '../pages/create-user'))
export { Page_CreateUser }

const Page_Error = load(() => import(/* webpackChunkName: "Page_Error" */ '../pages/error'))
export { Page_Error }

const Page_FindCareOptions_AdditionalQuestions = load(() => import(/* webpackChunkName: "Page_FindCareOptions_AdditionalQuestions" */ '../pages/find-care-options/additional-questions'))
export { Page_FindCareOptions_AdditionalQuestions }

const Page_FindCareOptions_CareOptionsResult = load(() => import(/* webpackChunkName: "Page_FindCareOptions_CareOptionsResult" */ '../pages/find-care-options/care-options-result'))
export { Page_FindCareOptions_CareOptionsResult }

const Page_FindCareOptions_CareOptions = load(() => import(/* webpackChunkName: "Page_FindCareOptions_CareOptions" */ '../pages/find-care-options/care-options'))
export { Page_FindCareOptions_CareOptions }

const Page_FindCareOptions_ConciergeCareInfo = load(() => import(/* webpackChunkName: "Page_FindCareOptions_ConciergeCareInfo" */ '../pages/find-care-options/concierge-care-info'))
export { Page_FindCareOptions_ConciergeCareInfo }

const Page_FindCareOptions_ConciergeCareResult = load(() => import(/* webpackChunkName: "Page_FindCareOptions_ConciergeCareResult" */ '../pages/find-care-options/concierge-care-result'))
export { Page_FindCareOptions_ConciergeCareResult }

const Page_FindCareOptions_ConciergeCare = load(() => import(/* webpackChunkName: "Page_FindCareOptions_ConciergeCare" */ '../pages/find-care-options/concierge-care'))
export { Page_FindCareOptions_ConciergeCare }

const Page_FindCareOptions_ConciergeConfirmScreen = load(() => import(/* webpackChunkName: "Page_FindCareOptions_ConciergeConfirmScreen" */ '../pages/find-care-options/concierge-confirm-screen'))
export { Page_FindCareOptions_ConciergeConfirmScreen }

const Page_FindCareOptions_Confirm = load(() => import(/* webpackChunkName: "Page_FindCareOptions_Confirm" */ '../pages/find-care-options/confirm'))
export { Page_FindCareOptions_Confirm }

const Page_FindCareOptions_Covid = load(() => import(/* webpackChunkName: "Page_FindCareOptions_Covid" */ '../pages/find-care-options/covid'))
export { Page_FindCareOptions_Covid }

const Page_FindCareOptions_Done = load(() => import(/* webpackChunkName: "Page_FindCareOptions_Done" */ '../pages/find-care-options/done'))
export { Page_FindCareOptions_Done }

const Page_FindCareOptions_EmergencyQuestion = load(() => import(/* webpackChunkName: "Page_FindCareOptions_EmergencyQuestion" */ '../pages/find-care-options/emergency-question'))
export { Page_FindCareOptions_EmergencyQuestion }

const Page_FindCareOptions_Emergency = load(() => import(/* webpackChunkName: "Page_FindCareOptions_Emergency" */ '../pages/find-care-options/emergency'))
export { Page_FindCareOptions_Emergency }

const Page_FindCareOptions_HouseVisitResult = load(() => import(/* webpackChunkName: "Page_FindCareOptions_HouseVisitResult" */ '../pages/find-care-options/house-visit-result'))
export { Page_FindCareOptions_HouseVisitResult }

const Page_FindCareOptions_HouseVisit = load(() => import(/* webpackChunkName: "Page_FindCareOptions_HouseVisit" */ '../pages/find-care-options/house-visit'))
export { Page_FindCareOptions_HouseVisit }

const Page_FindCareOptions = load(() => import(/* webpackChunkName: "Page_FindCareOptions" */ '../pages/find-care-options'))
export { Page_FindCareOptions }

const Page_FindCareOptions_Location = load(() => import(/* webpackChunkName: "Page_FindCareOptions_Location" */ '../pages/find-care-options/location'))
export { Page_FindCareOptions_Location }

const Page_FindCareOptions_NLPsymptom = load(() => import(/* webpackChunkName: "Page_FindCareOptions_NLPsymptom" */ '../pages/find-care-options/NLPsymptom'))
export { Page_FindCareOptions_NLPsymptom }

const Page_FindCareOptions_PatientdetailsConfoScreen = load(() => import(/* webpackChunkName: "Page_FindCareOptions_PatientdetailsConfoScreen" */ '../pages/find-care-options/patientdetails-confo-screen'))
export { Page_FindCareOptions_PatientdetailsConfoScreen }

const Page_FindCareOptions_Questions = load(() => import(/* webpackChunkName: "Page_FindCareOptions_Questions" */ '../pages/find-care-options/questions'))
export { Page_FindCareOptions_Questions }

const Page_FindCareOptions_QuickTelemedicineScreen = load(() => import(/* webpackChunkName: "Page_FindCareOptions_QuickTelemedicineScreen" */ '../pages/find-care-options/quick-telemedicine-screen'))
export { Page_FindCareOptions_QuickTelemedicineScreen }

const Page_FindCareOptions_RelatedSymptoms = load(() => import(/* webpackChunkName: "Page_FindCareOptions_RelatedSymptoms" */ '../pages/find-care-options/related-symptoms'))
export { Page_FindCareOptions_RelatedSymptoms }

const Page_FindCareOptions_SendInformation = load(() => import(/* webpackChunkName: "Page_FindCareOptions_SendInformation" */ '../pages/find-care-options/send-information'))
export { Page_FindCareOptions_SendInformation }

const Page_FindCareOptions_Start = load(() => import(/* webpackChunkName: "Page_FindCareOptions_Start" */ '../pages/find-care-options/start'))
export { Page_FindCareOptions_Start }

const Page_FindCareOptions_SymptomPriority = load(() => import(/* webpackChunkName: "Page_FindCareOptions_SymptomPriority" */ '../pages/find-care-options/symptom-priority'))
export { Page_FindCareOptions_SymptomPriority }

const Page_FindCareOptions_Symptoms = load(() => import(/* webpackChunkName: "Page_FindCareOptions_Symptoms" */ '../pages/find-care-options/symptoms'))
export { Page_FindCareOptions_Symptoms }

const Page_FindCareOptions_TelemedConfirmScreen = load(() => import(/* webpackChunkName: "Page_FindCareOptions_TelemedConfirmScreen" */ '../pages/find-care-options/telemed-confirm-screen'))
export { Page_FindCareOptions_TelemedConfirmScreen }

const Page_FindCareOptions_TelemedConnectiontype = load(() => import(/* webpackChunkName: "Page_FindCareOptions_TelemedConnectiontype" */ '../pages/find-care-options/telemed-connectiontype'))
export { Page_FindCareOptions_TelemedConnectiontype }

const Page_FindCareOptions_TelemedPharmaPrompt = load(() => import(/* webpackChunkName: "Page_FindCareOptions_TelemedPharmaPrompt" */ '../pages/find-care-options/telemed-pharma-prompt'))
export { Page_FindCareOptions_TelemedPharmaPrompt }

const Page_FindCareOptions_TelemedVideoprompt = load(() => import(/* webpackChunkName: "Page_FindCareOptions_TelemedVideoprompt" */ '../pages/find-care-options/telemed-videoprompt'))
export { Page_FindCareOptions_TelemedVideoprompt }

const Page_FindCareOptions_TelemedicineInfo = load(() => import(/* webpackChunkName: "Page_FindCareOptions_TelemedicineInfo" */ '../pages/find-care-options/telemedicine-info'))
export { Page_FindCareOptions_TelemedicineInfo }

const Page_FindCareOptions_TelemedicineResult = load(() => import(/* webpackChunkName: "Page_FindCareOptions_TelemedicineResult" */ '../pages/find-care-options/telemedicine-result'))
export { Page_FindCareOptions_TelemedicineResult }

const Page_FindCareOptions_Telemedicine = load(() => import(/* webpackChunkName: "Page_FindCareOptions_Telemedicine" */ '../pages/find-care-options/telemedicine'))
export { Page_FindCareOptions_Telemedicine }

const Page_FindCareOptions_ThankYou = load(() => import(/* webpackChunkName: "Page_FindCareOptions_ThankYou" */ '../pages/find-care-options/thank-you'))
export { Page_FindCareOptions_ThankYou }

const Page_FindFacility = load(() => import(/* webpackChunkName: "Page_FindFacility" */ '../pages/find-facility'))
export { Page_FindFacility }

const Page_Index = load(() => import(/* webpackChunkName: "Page_Index" */ '../pages/index'))
export { Page_Index }

const Page_Terms = load(() => import(/* webpackChunkName: "Page_Terms" */ '../pages/terms'))
export { Page_Terms }

const Page_Test_CareOptionsResult = load(() => import(/* webpackChunkName: "Page_Test_CareOptionsResult" */ '../pages/test/care-options-result'))
export { Page_Test_CareOptionsResult }

const Page_Test_CareOptions = load(() => import(/* webpackChunkName: "Page_Test_CareOptions" */ '../pages/test/care-options'))
export { Page_Test_CareOptions }

const Page_Test_EmergencyResult = load(() => import(/* webpackChunkName: "Page_Test_EmergencyResult" */ '../pages/test/emergency-result'))
export { Page_Test_EmergencyResult }

const Page_Test_HomeAnimation = load(() => import(/* webpackChunkName: "Page_Test_HomeAnimation" */ '../pages/test/home-animation'))
export { Page_Test_HomeAnimation }

const Page_Test = load(() => import(/* webpackChunkName: "Page_Test" */ '../pages/test'))
export { Page_Test }

const Page_Test_ThankYou2Animation = load(() => import(/* webpackChunkName: "Page_Test_ThankYou2Animation" */ '../pages/test/thank-you-2-animation'))
export { Page_Test_ThankYou2Animation }

const Page_Test_ThankYouAnimation = load(() => import(/* webpackChunkName: "Page_Test_ThankYouAnimation" */ '../pages/test/thank-you-animation'))
export { Page_Test_ThankYouAnimation }

const Page_TriageNew = load(() => import(/* webpackChunkName: "Page_TriageNew" */ '../pages/triageNew'))
export { Page_TriageNew }

// Map routes to component
export const pageMap = {
  '404': Page_404,
  'check-policy': Page_CheckPolicy,
  'create-details': Page_CreateDetails,
  'create-primary': Page_CreatePrimary,
  'create-profile': Page_CreateProfile,
  'create-user': Page_CreateUser,
  'error': Page_Error,
  'find-care-options/additional-questions': Page_FindCareOptions_AdditionalQuestions,
  'find-care-options/care-options-result': Page_FindCareOptions_CareOptionsResult,
  'find-care-options/care-options': Page_FindCareOptions_CareOptions,
  'find-care-options/concierge-care-info': Page_FindCareOptions_ConciergeCareInfo,
  'find-care-options/concierge-care-result': Page_FindCareOptions_ConciergeCareResult,
  'find-care-options/concierge-care': Page_FindCareOptions_ConciergeCare,
  'find-care-options/concierge-confirm-screen': Page_FindCareOptions_ConciergeConfirmScreen,
  'find-care-options/confirm': Page_FindCareOptions_Confirm,
  'find-care-options/covid': Page_FindCareOptions_Covid,
  'find-care-options/done': Page_FindCareOptions_Done,
  'find-care-options/emergency-question': Page_FindCareOptions_EmergencyQuestion,
  'find-care-options/emergency': Page_FindCareOptions_Emergency,
  'find-care-options/house-visit-result': Page_FindCareOptions_HouseVisitResult,
  'find-care-options/house-visit': Page_FindCareOptions_HouseVisit,
  'find-care-options': Page_FindCareOptions,
  'find-care-options/location': Page_FindCareOptions_Location,
  'find-care-options/NLPsymptom': Page_FindCareOptions_NLPsymptom,
  'find-care-options/patientdetails-confo-screen': Page_FindCareOptions_PatientdetailsConfoScreen,
  'find-care-options/questions': Page_FindCareOptions_Questions,
  'find-care-options/quick-telemedicine-screen': Page_FindCareOptions_QuickTelemedicineScreen,
  'find-care-options/related-symptoms': Page_FindCareOptions_RelatedSymptoms,
  'find-care-options/send-information': Page_FindCareOptions_SendInformation,
  'find-care-options/start': Page_FindCareOptions_Start,
  'find-care-options/symptom-priority': Page_FindCareOptions_SymptomPriority,
  'find-care-options/symptoms': Page_FindCareOptions_Symptoms,
  'find-care-options/telemed-confirm-screen': Page_FindCareOptions_TelemedConfirmScreen,
  'find-care-options/telemed-connectiontype': Page_FindCareOptions_TelemedConnectiontype,
  'find-care-options/telemed-pharma-prompt': Page_FindCareOptions_TelemedPharmaPrompt,
  'find-care-options/telemed-videoprompt': Page_FindCareOptions_TelemedVideoprompt,
  'find-care-options/telemedicine-info': Page_FindCareOptions_TelemedicineInfo,
  'find-care-options/telemedicine-result': Page_FindCareOptions_TelemedicineResult,
  'find-care-options/telemedicine': Page_FindCareOptions_Telemedicine,
  'find-care-options/thank-you': Page_FindCareOptions_ThankYou,
  'find-facility': Page_FindFacility,
  '': Page_Index,
  'terms': Page_Terms,
  'test/care-options-result': Page_Test_CareOptionsResult,
  'test/care-options': Page_Test_CareOptions,
  'test/emergency-result': Page_Test_EmergencyResult,
  'test/home-animation': Page_Test_HomeAnimation,
  'test': Page_Test,
  'test/thank-you-2-animation': Page_Test_ThankYou2Animation,
  'test/thank-you-animation': Page_Test_ThankYouAnimation,
  'triageNew': Page_TriageNew
}
